module.exports = __webpack_public_path__ + "./assets/icons/abstract-user-flat-4.svg";